import { render } from "./SubmitCarFax.vue?vue&type=template&id=78dce9e6&scoped=true&ts=true"
import script from "./SubmitCarFax.vue?vue&type=script&lang=ts"
export * from "./SubmitCarFax.vue?vue&type=script&lang=ts"

import "./SubmitCarFax.vue?vue&type=style&index=0&id=78dce9e6&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\TTI.AVE.Web\\Vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78dce9e6"]])

export default __exports__